var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('v-btn',{staticClass:"lighten-1",attrs:{"fab":"","x-small":"","color":_vm.color,"absolute":"","top":"","right":""},on:{"click":_vm.copy}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),(_vm.hide===false)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }